import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Media, Row } from "reactstrap";
import gifImage from "../../../../public/images/Congrats.gif";
import {
  getBaseUrl,
  daysNameEvaluation,
  monthNames,
} from "../../../../actions/utility";
import ChaptersAccordion from "./ChaptersAccordion";
import yTubeIcon from "../../../../public/images/youtubeIcon.svg";
import worksheetIcon from "../../../../public/images/google-docs.png";
import customerIcon from "../../../../public/images/customer-support.png";
import moment from "moment";
import plannerImage from "../../../../public/images/Picture2.jpg";
import "moment-timezone";
import { getTesstParameter } from "../../../../actions/feedActions";
import ScoresLeaderBoard from "../../../ReuseComponenets/ScoresLeaderBoard";

const PlannerDataFeed = (props) => {
  const { item } = props;
  const { feed_data } = item;
  debugger;
  const [showChapters, setshowChapters] = useState(false);
  const [videoCount, setvideoCount] = useState("");
  const [smileyArray, setsmileyArray] = useState([
    { id: 1, value: null },
    { id: 2, value: null },
    { id: 3, value: null },
    { id: 4, value: null },
    { id: 5, value: null },
    { id: 6, value: null },
    { id: 7, value: null },
    { id: 8, value: null },
  ]);

  useEffect(() => {
    // var tempArray = [];
    // JSON.parse(feed_data).planner_topic &&
    //   JSON.parse(feed_data).planner_topic.map((planner, index) =>
    //     planner.worksheet.map((worksheet, index2) => {
    //       tempArray.push({ id: index2 + 1, value: null });
    //       setsmileyArray(tempArray);
    //     })
    //   );
  }, []);
  // console.log(
  //   "JSON Format",
  //   item.feed_data && item.feed_data && JSON.parse(item.feed_data)
  // );

  if (item.feed_data && item.feed_data && JSON.parse(item.feed_data)) {
    var data = 0;
    const result = JSON.parse(item.feed_data).planner_topic?.map((item) => {
      return data + item.videos.length;
    });

    console.log("Videos", result);
    // console.log(
    //   "Total Video",
    //   result &&
    //     result.reduce(function (a, b) {
    //       return a + b;
    //     })
    // ); // => 7
    // console.log("Total Video 2", [{ x: 1 }, { x: 2 }, { x: 4 }]); // => 7
    // console.log(
    //   "Total Video Function",
    //   JSON.parse(item.feed_data).planner_topic &&
    //     JSON.parse(item.feed_data).planner_topic.reduce((a, b) => ({
    //       videos: a.videos.length + b.videos.length,
    //     }))
    // ); // => 7
  }

  const TDate = (scheduledTime) => {
    var ToDate = new Date();

    if (new Date(scheduledTime).getTime() <= ToDate.getTime()) {
      // alert("The Date must be Bigger or Equal to today date");
      return true;
    }
    return false;
  };

  const getVideosCount = () => {
    var reduced = JSON.parse(item.feed_data).planner_topic?.reduce(function (
      r,
      a
    ) {
      return r + a.videos.length;
    },
    0);

    if (
      typeof reduced != "undefined" &&
      typeof reduced != "null" &&
      reduced != 0
    ) {
      return <span>, {reduced} Videos</span>;
    } else return null;
  };
  const redirectToTest = (testId, chapterId, programId, studentId) => {
    debugger;
    getTesstParameter(testId, studentId)
      .then((res) => {
        window.open(
          `https://dashboard.lincolnmethod.com/signin?continue_session=true&student_id=${studentId}&program=${programId}&test_taken=${res.data}&testid=${testId}&assessid=${chapterId}&practice=0&txt_program=${programId}`,
          "_blank"
        );
        debugger;
      })
      .catch((err) => {});
  };
  const getWorksheetsCount = () => {
    var reduced = JSON.parse(item.feed_data).planner_topic?.reduce(function (
      r,
      a
    ) {
      return r + a.worksheet.length;
      //    ^^^ use the last result without property
    },
    0);

    if (
      typeof reduced != "undefined" &&
      typeof reduced != "null" &&
      reduced != 0
    ) {
      return <span>, {reduced} Worksheets</span>;
    } else return null;
  };

  const rendringSmileys = (data, value) => {
    var newTemp = smileyArray.filter((item) => item.id == data.id);
    newTemp[0].value = value;
    setsmileyArray([...smileyArray, newTemp]);
    debugger;
  };
  const currentTimeZone = moment.tz.guess();
  console.log("Date in browser", new Date().getDay());

  // // download file or documents from the posted feeds

  const downloadFile = async (fileUrl, filename, defaultExtension) => {
    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;

      // Set the download attribute and filename
      const fileExtension = fileUrl.split(".").pop() || defaultExtension;
      const fullFilename = `${filename}.${fileExtension}`;
      link.setAttribute("download", fullFilename);

      console.log('link as:', link)
      // Trigger the download
      link.click();
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };
  return (
    <Card
      style={{
        marginBottom: "2vh",
        border: "1px #ccc solid",
        textAlign: "left",
      }}
      className="homeSection"
      id={item.user_feedid}
    >
      <CardBody style={{ padding: 0 }}>
        <div style={{ padding: "1.25rem" }}>
          <div className="d-flex tutorImageSection">
            <div>
              {/* <img
                className="mt-1"
                src={`https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/${item.teacher_image}`}
                width="40"
                height="40"
              /> */}
              {item.teacher_image ? (
    <img
      className="mt-1"
      src={`https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/${item.teacher_image}`}
      width="40"
      height="40"
      alt="Teacher"
    />
  ) : (
    // <i class="fa-regular fa-user fa-2x mt-1 text-muted"></i>
    <i
      className="fa-solid fa-user mt-1 text-muted d-flex align-items-center justify-content-center"
      style={{
        fontSize: "1.5rem",
        width: "40px",
        height: "40px",
        borderRadius: "50%",
        backgroundColor: "#ccc", // Optional: adds a background to match an avatar
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    ></i>
  )}
            </div>
            <div className="ml-2">
              <label>
                {item.teacher_name}
                <strong> shared </strong> more things to do
              </label>{" "}
              {/* <br /> */}
              <div className="">
                <span className="gradeName text-primary">
                  {item.course_name}
                </span>{" "}
                {/* <span style={{fontSize: 10}}>{moment.tz(item.created_at , "Asia/Karachi").fromNow()}</span> <br /> */}
                <span style={{ fontSize: 9 }}>
                  {moment
                    .tz(item.created_at, "Asia/Karachi")
                    .tz(currentTimeZone)
                    .fromNow()}
                </span>
              </div>
            </div>
          </div>
          {/* <div className="mt-3">
            <label
              dangerouslySetInnerHTML={{
                __html: JSON.parse(feed_data).message,
              }}
            ></label>
          </div> */}
        </div>
        <Row style={{ margin: 0 }}>
          <Col
            className="classStartFeedImg"
            style={{
              backgroundImage:
                "url(" +
                "https://images.unsplash.com/photo-1606926693780-ec99c3f747f3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80" +
                ")",
            }}
          >
            <Row className="">
              <Col xs={6}>
                <div className="details right">
                  <label className="mb-0" style={{ fontSize: "12px" }}>
                    <span
                      className="dayCircle"
                      style={
                        moment(item.created_at).format("dddd") == "Friday"
                          ? { background: "#B30493" }
                          : moment(item.created_at).format("dddd") ==
                            "Wednesday"
                          ? { background: "#B30493" }
                          : { background: "#F6A00E" }
                      }
                    >
                      {moment(item.created_at).format("dddd")}
                    </span>{" "}
                    <br /> <h5 className="mt-2"> More things to do </h5>
                  </label>
                  <div className="hrLineFeed" />
                  {/* <hr /> */}
                  <p className="mt-2">We will cover:</p>
                  <label style={{ fontSize: "12px" }}>
                    {JSON.parse(feed_data)?.planner_topic?.length > 0
                      ? JSON.parse(feed_data)?.planner_topic?.length
                      : "0"}{" "}
                    Topic {getWorksheetsCount()} {getVideosCount()}
                  </label>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        {item.is_zoom == 1 ? (
          <>
            {TDate(item.scheduled_date_time) ? (
              <div className="mt-3">
                <label className="font-weight-bold">Your class was on:</label>
                <p>
                  Date:{" "}
                  {
                    daysNameEvaluation[
                      new Date(item.scheduled_date_time).getDay()
                    ]
                  }{" "}
                  {new Date(item.scheduled_date_time).getDate()}{" "}
                  {monthNames[new Date(item.scheduled_date_time).getMonth()]}{" "}
                  <br />
                  Time:{" "}
                  {new Date(item.scheduled_date_time).toLocaleTimeString(
                    "en-US",
                    {
                      hour: "2-digit",
                      minute: "2-digit",
                    }
                  )}{" "}
                  <br />
                  Teacher: {item.teacher_name}{" "}
                </p>
              </div>
            ) : (
              <>
                <div className="mt-3">
                  <label className="font-weight-bold">Your class is on:</label>
                  <p>
                    Date:{" "}
                    {
                      daysNameEvaluation[
                        new Date(item.scheduled_date_time).getDay()
                      ]
                    }{" "}
                    {new Date(item.scheduled_date_time).getDate()}{" "}
                    {monthNames[new Date(item.scheduled_date_time).getMonth()]}{" "}
                    <br />
                    Time:{" "}
                    {new Date(item.scheduled_date_time).toLocaleTimeString(
                      "en-US",
                      {
                        hour: "2-digit",
                        minute: "2-digit",
                      }
                    )}{" "}
                    <br />
                    Teacher: {item.teacher_name}{" "}
                  </p>
                </div>
                <button
                  className="btn btn-success zoomBtn"
                  onClick={() => window.open(item.zoomlink, "_blank")}
                >
                  Click to join your class online
                </button>
              </>
            )}
          </>
        ) : null}
        {item.feed_label == "planner_data" ? (
          <div style={{ padding: "1.25rem" }}>
            {JSON.parse(feed_data).planner_topic?.length > 0 ? (
              <label>Topic(s) covered in class today:</label>
            ) : null}
            <br />
            {JSON.parse(feed_data).planner_topic &&
              JSON.parse(feed_data).planner_topic.map((planner, index) => (
                <>
                  <div className="d-flex">
                    <i className="fa fa-commenting mr-2 text-success fa-2x"></i>
                    <div>
                      <label className="mb-0 font-weight-bold">
                        {" "}
                        {planner.topicName}
                      </label>
                      <p
                        className="text-italic"
                        style={{ fontSize: 12, color: "#c1c1c1" }}
                      >
                        (Chapter: {planner.chapterName})
                      </p>
                    </div>
                  </div>
                  <div className="">
                    {planner.worksheet.length > 0 && (
                      <label>Worksheet(s):</label>
                    )}
                    <div className="">
                      {planner.worksheet.map((worksheet, index2) => (
                        <div className="container">
                          <div className="row">
                            <div className="col-1 p-0" key={index2}>
                              <Media
                                width={20}
                                height={20}
                                object
                                src={worksheetIcon}
                                alt={worksheetIcon}
                              />
                            </div>
                            <div className="col-8 p-0">
                              <label className="">
                                {/* <a href={worksheet.link} target="_new">
                                  {worksheet.label}
                                </a> */}

                                <a
                                  href={worksheet.link}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    downloadFile(
                                      worksheet.link,
                                      worksheet.label,
                                      "pdf"
                                    );
                                  }}
                                >
                                  {worksheet.label}
                                </a>
                              </label>
                            </div>
                            <div className="col-3 p-0 text-center">
                              {/* <>
                                <i
                                  className={
                                    smileyArray[index2].value == "happy"
                                      ? "far fa-smile-o mr-2 smileSelect"
                                      : "far fa-smile-o mr-2 iconsCss"
                                  }
                                  style={
                                    smileyArray[index2].value == "happy"
                                      ? { fontSize: 18 }
                                      : { fontSize: 16 }
                                  }
                                  onClick={() => rendringSmileys(smileyArray[index2], "happy")}
                                />
                                <i
                                  className={
                                    smileyArray[index2].value == "sad"
                                      ? "far fa-frown-o sadSelect"
                                      : "far fa-frown-o iconsCss"
                                  }
                                  style={
                                    smileyArray[index2].value == "sad"
                                      ? { fontSize: 18 }
                                      : { fontSize: 16 }
                                  }
                                  onClick={() => rendringSmileys(smileyArray[index2], "sad")}
                                />
                              </> */}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="">
                    {planner.videos.length > 0 && <label>Video(s):</label>}
                    <div className="">
                      {planner.videos.map((video, index3) => (
                        <div className="container">
                          <div className="row">
                            <div className="col-1 p-0" key={index3}>
                              <Media
                                width={20}
                                height={20}
                                object
                                src={yTubeIcon}
                                alt={yTubeIcon}
                              />
                            </div>
                            <div className="col-11 p-0">
                              <label className="">
                                <a href={video.video_url} target="_new">
                                  {video.video_caption}
                                </a>
                              </label>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {planner.has_questions ? (
                    <div className="text-right">
                      {/* <label style={{ color: "#218838" }} className="mr-2">
                      Score
                    </label>{" "}
                    <label className="percent">
                      {topicsData[topics]["beforeScore"]}%
                    </label>{" "} */}
                      {/* <a
                      target="__blank"
                      href={`https://dashboard.lincolnmethod.com/signin?continue_session=true&student_id=${item.student_id}&prog_id=${item.prog_id}&assess_id=${planner.chapterId}&test_id=${planner.topicId}`}
                      className=""
                    > */}
                      <button
                        onClick={() =>
                          redirectToTest(
                            planner.topicId,
                            planner.chapterId,
                            item.prog_id,
                            item.student_id
                          )
                        }
                        className="btn btn-lg"
                        style={{
                          minHeight: 45,
                          background: "#D7E7F7",
                          color: "#3D3D3D",
                          fontSize: 14,
                        }}
                      >
                        {planner?.otherStudents.length > 0 &&
                        planner?.otherStudents?.some((obj) =>
                          Object.values(obj)?.includes(item?.student_name)
                        )
                          ? "Re-do Quiz"
                          : "Start Quiz"}
                      </button>
                      {/* </a> */}
                    </div>
                  ) : null}
                  <ScoresLeaderBoard scoresData={planner.otherStudents} />
                  <hr />
                  {/* {JSON.parse(feed_data).planner_topic?.length ==
                  index + 1  ? null : (
                    <hr />
                  )} */}
                </>
              ))}
          </div>
        ) : null}

        {item.is_practice == 1 ? (
          <>
            <button
              className={
                showChapters
                  ? "btn takeTest mt-3"
                  : "btn btn-success zoomBtn mt-3"
              }
              onClick={() => setshowChapters(!showChapters)}
            >
              {showChapters
                ? "Select a chapter and a topic below"
                : "Take a practice test while you wait"}
            </button>
            {showChapters ? (
              <ChaptersAccordion
                programId={item.prog_id}
                studentId={item.student_id}
              />
            ) : null}
          </>
        ) : null}
      </CardBody>
    </Card>
  );
};

export default PlannerDataFeed;
